import { Directive, ElementRef, Input, SimpleChanges } from "@angular/core";

@Directive({
  selector: '[autoFocus]'
})
export class AutofocusDirective {
  constructor(private hostElement: ElementRef) { }
  @Input() set autoFocus(focus: boolean) {
    if (focus) {
        this.hostElement.nativeElement.focus();
    }
  }
}
